import AnimatedMain from './AnimatedMain';

new AnimatedMain().init();
